<template>
  <div v-if="display">
    <b-row>
      <b-col cols="5">
        <h4 class="card-title mt-4"><i class="fal fa-chart-bar"></i> {{$t('views.application.show.activeagreements')}}</h4>
      </b-col>
      <b-col cols="7">
        <label>{{$t("views.application.show.dateRange")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="dateRangeAgreements" v-model="dateRange" name="dateRangeAgreements">
            <b-form-radio class="btn-sm" size="sm" button-variant="outline-primary" :value="1">{{$t('views.application.show.last30days')}}</b-form-radio>
            <b-form-radio class="btn-sm" size="sm" button-variant="outline-primary" :value="2">{{$t('views.application.show.last60days')}}</b-form-radio>
            <b-form-radio class="btn-sm" size="sm" button-variant="outline-primary" :value="3">{{$t('views.application.show.last90days')}}</b-form-radio>
            <b-form-radio class="btn-sm" size="sm" button-variant="outline-primary" :value="4">{{$t('views.application.show.last180days')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="p-4">
      <vue-chart type="line" :data="valuesChartData" :options="chartOptions" style="position:relative;width: 100%;height: 300px;"></vue-chart>
      <h5 class="mt-4">{{$t('views.application.show.activeAgreementsAverage')}}: {{last.activeAgreementsAverage}}</h5>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import VueChart from 'vue-chart-js'
import moment from 'moment'
export default {
  name: 'activeAgreementsChartBox',
  components: {
    VueChart
  },
  props: {
    dataIncoming: {
      type: Array,
      default: null,
      description: 'data array'
    }
  },
  data () {
    return {
      moment,
      display: false,
      dateRange: 1,
      data: [],
      last: {},
      valuesChartData: {
        labels: [],
        datasets: [
          {
            type: 'line',
            label: this.$t('views.application.show.activeagreements'),
            data: [],
            backgroundColor: 'rgba(27, 126, 193, 0.1)'
          },
          {
            type: 'line',
            label: this.$t('views.application.show.inactiveAgreements'),
            data: [],
            backgroundColor: 'rgba(255, 0, 0, 0.1)'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }]
        }
      }
    }
  },
  created () {
    this.data = this.dataIncoming
    this.formatData()
  },
  watch: {
    dateRange () {
      this.formatData()
    }
  },
  methods: {
    formatData () {
      if (this.data !== null) {
        if (this.data.length > 0) {
          this.last = this.data[0]
        }
        this.display = true
        this.valuesChartData.datasets[0].data = []
        this.valuesChartData.datasets[1].data = []
        this.valuesChartData.labels = []
        let maxDaysBefore = 30
        if (this.dateRange === 2) {
          maxDaysBefore = 60
        } else if (this.dateRange === 3) {
          maxDaysBefore = 90
        } else if (this.dateRange === 4) {
          maxDaysBefore = 180
        }
        for (let i in this.data) {
          let minDate = moment().add(-maxDaysBefore, 'days')
          let stampDate = moment(this.data[i].stampDate.date)
          if (stampDate > minDate) {
            this.valuesChartData.labels.unshift(stampDate.format('YYYY-MM-DD'))
            this.valuesChartData.datasets[0].data.unshift(this.data[i].activeAgreements)
            this.valuesChartData.datasets[1].data.unshift(this.data[i].inactiveAgreements)
          }
        }
      }
    }
  }
}
</script>
